import { RadioGroup as MUIRadioGroup, RadioGroupProps } from '@mui/material';
export const RadioGroup = ({ ...props }: RadioGroupProps) => (
  <MUIRadioGroup {...props} />
);
